<template>
  <div class="flex items-center gap-2 shrink-0">
    <Button
      v-for="item in options"
      :key="item.value"
      variant="fill"
      shape="corner"
      :color="modelValue === item.value ? 'blue2' : 'normal'"
      size="sm"
      :active="modelValue === item.value"
      :disabled="disabled"
      :class="props.class"
      @click="$emit('update:modelValue', item.value)"
    >
      {{ item.label }}
    </Button>
  </div>
</template>

<script setup lang="ts">
  import { computed, HtmlHTMLAttributes } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { Button } from '@rapoo/element'
  import type { RtSelectionMode } from '../types'

  const props = defineProps<{
    modelValue: RtSelectionMode
    class?: HtmlHTMLAttributes['class']
    disabled?: boolean
  }>()

  defineEmits<{
    'update:modelValue': [value: RtSelectionMode]
  }>()

  const { t } = useI18n()

  const options = computed<Array<{ value: RtSelectionMode; label: string }>>(() => [
    { value: 'both', label: t('rt.mode.both') },
    { value: 'left', label: t('rt.mode.left') },
    { value: 'right', label: t('rt.mode.right') },
  ])
</script>
